"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const react_native_config_1 = __importDefault(require("react-native-config"));
const react_native_1 = require("react-native");
const BACKEND_URL = react_native_1.Platform.OS === 'web' ? process.env.API_URL : react_native_config_1.default.API_URL;
axios_1.default.defaults.baseURL = BACKEND_URL;
axios_1.default.defaults.headers = {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
};
class PharmacyService {
    static async getPharmacies(filter) {
        const token = await async_storage_1.default.getItem('JWT');
        if (filter === undefined) {
            filter = '';
        }
        return new Promise(resolve => {
            axios_1.default
                .get(`/pharmacy/filter/${filter}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async savePatientPharmacyRelation(data) {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .post('/pharmacy/relation', data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
    static async createPharmacy(data) {
        const token = await async_storage_1.default.getItem('JWT');
        return new Promise(resolve => {
            axios_1.default
                .post('/pharmacy', data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            })
                .then(response => {
                resolve({ error: false, data: response.data });
            })
                .catch(error => {
                resolve({ error: true, message: error });
            });
        });
    }
}
exports.default = PharmacyService;
